const state = {};

const getters = {
  getTooltipConfig: (state, getters) => payload => {
    if (!getters.getIsTooltipsActive) {
      return null;
    }
    const data = getters.getWebProductData.tooltips.config;
    if (data[payload]) {
      return parseInt(data[payload]);
    }
    return null;
  },
  getTooltipContent: (state, getters) => tooltip => {
    if (!getters.getIsTooltipsActive) {
      return null;
    }
    const data = getters.getWebProductData.tooltips.data;
    if (data[tooltip]) {
      return data[tooltip];
    }
    return null;
  },
  getIsTooltipsActive: (state, getters) => {
    return getters.getWebProductData.tooltips ? true : false;
  },
  getShowTooltipsInPOV: (state, getters) => {
    return (
      getters.getShowTooltipsInMobile && getters.getTooltipConfig("pov_matrix")
    );
  },
  getShowTooltipsInPOHeader: (state, getters) => {
    return (
      getters.getShowTooltipsInMobile && getters.getTooltipConfig("po_matrix")
    );
  },
  getShowTooltipsInPOPoptext: (state, getters) => {
    return (
      getters.getShowTooltipsInMobile && getters.getTooltipConfig("po_poptext")
    );
  },
  getShowTooltipsInMobile: (state, getters) => {
    if (getters.getIsMobile) {
      return getters.getTooltipConfig("mobile");
    }
    return true;
  },
  getShowTooltipsInPOVPoptext: (state, getters) => {
    if (getters.getIsMobile) {
      return false;
    }
    return getters.getTooltipConfig("pov_poptext");
  }
};

const mutations = {};

const actions = {};

export default {
  state,
  mutations,
  actions,
  getters
};
